import axios from "axios";
import toQueryString from "../common/utils/to-query-string";

const withoutPeriodFilter = (query = {}) => {
  const { period, ...rest } = query;
  return rest;
};

const getScenarioAnalytics = (query) =>
  axios.get(toQueryString("api/v1/analytics/scenarios?", query));

const getScenarioAnalyticsById = (id, query) =>
  axios.get(toQueryString(`api/v1/analytics/scenarios/${id}?`, query));

const getTaskAnalytics = (query) =>
  axios.get(toQueryString("api/v1/analytics/daily-tasks?", withoutPeriodFilter(query)));

const getTaskAnalyticsById = (id, query) =>
  axios.get(toQueryString(`api/v1/analytics/daily-tasks/${id}?`, withoutPeriodFilter(query)));

const getOnboardingAnalytics = (query) =>
  axios.get(toQueryString("api/v1/analytics/onboardings?", query));

const getOnboardingAnalyticsById = (id, query) =>
  axios.get(toQueryString(`api/v1/analytics/onboardings/${id}?`, query));

const getSurveyReports = (query = {}) =>
  axios.get(toQueryString("api/v1/reports/surveys?", query));

const exportSurveysReport = (query = {}) =>
  axios.get(toQueryString("api/v1/reports/surveys/export?", query), {
    responseType: "blob",
  });

const getSurveyReportPreview = (query = {}) =>
  axios.get(toQueryString("api/v1/reports/surveys/preview?", query));

const getOnboardingReports = (query = {}) =>
  axios.get(toQueryString("api/v1/reports/onboardings?", query));

const exportOnboardingsReport = (query = {}) =>
  axios.get(toQueryString("api/v1/reports/onboardings/export?", query), {
    responseType: "blob",
  });

const getOnboardingReportPreview = (query = {}) =>
  axios.get(toQueryString("api/v1/reports/onboardings/preview?", query));

const getUsageAnalytics = (period) =>
  axios.get(toQueryString("api/v1/analytics/usage?", { period }));

const ApiAnalytics = {
  getScenarioAnalytics,
  getScenarioAnalyticsById,
  getTaskAnalytics,
  getTaskAnalyticsById,
  getOnboardingAnalytics,
  getOnboardingAnalyticsById,
  getSurveyReports,
  exportSurveysReport,
  getSurveyReportPreview,
  getOnboardingReports,
  exportOnboardingsReport,
  getOnboardingReportPreview,
  getUsageAnalytics
};

export default ApiAnalytics;
